import * as React from 'react'
import * as R from 'ramda'

import { ItemLine } from './InputCategoryStyles'
import { SubAccordion, SubAccordionItem } from '../../Shared/Accordion'
import { EditableLoadCase } from '../../../reducers/project'
import Tooltip, { Side } from '../../Shared/Tooltip'
const tooltips = require('../../Shared/tooltips.json')

type Props = {
  loads: EditableLoadCase[] | null
  onTreeChanged: (items: number[]) => void
  openItems: number[]
  selectItem: (itemId: string) => any // tslint:disable-line no-any
  activeItem: string | null
}

type State = {
  tooltip: {
    id: string
    pos: { x: number; y: number }
  }
}

class InputLoads extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { tooltip: { id: '', pos: { x: 0, y: 0 } } }

    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
  }

  showTooltip(event: React.MouseEvent<HTMLElement>) {
    const id = event.currentTarget.getAttribute('id')
    const rect = event.currentTarget.getBoundingClientRect()
    this.setState({
      tooltip: {
        ...this.state.tooltip,
        id: id ? id : '',
        pos: {
          x: rect.left + rect.width + 10,
          y: rect.top + rect.height / 2
        }
      }
    })
  }

  hideTooltip() {
    this.setState({ tooltip: { ...this.state.tooltip, id: '' } })
  }

  render() {
    const {
      loads,
      onTreeChanged,
      openItems,
      selectItem,
      activeItem
    } = this.props
    if (!loads) {
      return null
    }
    const erectionTooltips: { id: string; text: string }[] = loads
      .filter(R.propEq('stage', 'erection'))
      .map((load: EditableLoadCase) => {
        let text = ''
        switch (load.name) {
          case 'Self weight (automatic)':
            text = tooltips.erectionSelfWeight
            break
          case 'Temporary (automatic)':
            text = tooltips.erectionTemporary
            break
          default:
            break
        }
        return { id: load.id, text: text }
      })
    const finalCompositeTooltips: { id: string; text: string }[] = loads
      .filter(R.propEq('stage', 'finalComposite'))
      .map((load: EditableLoadCase) => {
        let text = ''
        switch (load.name) {
          case 'Self weight (automatic)':
            text = tooltips.finalCompositeSelfWeight
            break
          case 'Permanent':
            text = tooltips.finalCompositePermanent
            break
          case 'Variable load':
            text = tooltips.finalCompositeVariableLoad
            break
          default:
            break
        }
        return { id: load.id, text: text }
      })

    return (
      <SubAccordion
        accordion={false}
        onChange={onTreeChanged}
        activeItems={openItems}
        expanded={true}
      >
        <SubAccordionItem expanded={true} title="Installation">
          {loads
            .filter(R.propEq('stage', 'erection'))
            .map((load: EditableLoadCase) => {
              const tooltip = R.find(l => l.id === load.id, erectionTooltips)
              const tooltipPos = this.state.tooltip.pos
              return (
                <ItemLine
                  id={load.id}
                  active={activeItem === load.id}
                  onClick={() => selectItem(load.id)}
                  key={load.id}
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                >
                  {load.name}
                  {tooltip && (
                    <Tooltip
                      tooltip={{
                        text: tooltip.text,
                        show: this.state.tooltip.id === load.id,
                        pos: tooltipPos,
                        side: Side.Right
                      }}
                    />
                  )}
                </ItemLine>
              )
            })}
        </SubAccordionItem>
        <SubAccordionItem expanded={true} title="Final composite">
          {loads
            .filter(R.propEq('stage', 'finalComposite'))
            .map((load: EditableLoadCase) => {
              const tooltip = R.find(
                l => l.id === load.id,
                finalCompositeTooltips
              )
              const tooltipPos = this.state.tooltip.pos
              return (
                <ItemLine
                  id={load.id}
                  active={activeItem === load.id}
                  onClick={() => selectItem(load.id)}
                  key={load.id}
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                >
                  {load.name}
                  {tooltip && (
                    <Tooltip
                      tooltip={{
                        text: tooltip.text,
                        show: this.state.tooltip.id === load.id,
                        pos: tooltipPos,
                        side: Side.Right
                      }}
                    />
                  )}
                </ItemLine>
              )
            })}
        </SubAccordionItem>
      </SubAccordion>
    )
  }
}

export default InputLoads



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/InputLoads.tsx